import React, {PureComponent} from 'react';
import $ from "jquery";
import Accents from "remove-accents";
import Alert from "react-s-alert";
import SessionClosedModal from "./sessionClosedWarningModalComponent";
import {confirmSession} from "../functions/api";
import ReactTooltip from "react-tooltip";
import {Modal} from 'react-responsive-modal';

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const telemetryPort = process.env.REACT_APP_MESSAGE_PORT;

class MessageComponent extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            messageResult: 0,
            messageCharacterLimit: (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? 57 : 73,
            teamOnlyMessage: false,
            messageHasTimeout: false,
            messageTimeoutValue: 0,
            driverMessage: "",
            messageTooltip: "Message Driver",
            messageBackground: "",
            messageIcon: "fas fa-envelope",
            messageAdditionalClass: "",
            messageSet: [],
            messageTooLong: false,
            messageWildcards: {
                livery_number: null,
            }
        };

        this.getMessageSet = this.getMessageSet.bind(this);
        this.updateWildcards = this.updateWildcards.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClearDriverScreen = this.handleClearDriverScreen.bind(this);
        this.handleSendMessage = this.handleSendMessage.bind(this);
        this.handleOnChangeMessage = this.handleOnChangeMessage.bind(this);
        this.handleTeamOnlyMessage = this.handleTeamOnlyMessage.bind(this);
        this.handleMessageTimeout = this.handleMessageTimeout.bind(this);
        this.handleTimeoutChange = this.handleTimeoutChange.bind(this);
        this.handleStandardMessage = this.handleStandardMessage.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        this.getMessageSet();
        this.updateWildcards();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            JSON.stringify(Object.keys(prevProps.pendingMsgTeam)) !== JSON.stringify(Object.keys(this.props.pendingMsgTeam)) ||
            JSON.stringify(Object.keys(prevProps.pendingMsgOrg)) !== JSON.stringify(Object.keys(this.props.pendingMsgOrg)) ||
            prevProps.carID !== this.props.carID
        ) {
            this.updateWildcards();
            if (this.props.pendingMsgTeam[this.props.carID] || this.props.pendingMsgOrg[this.props.carID]) {
                if (this.props.pendingMsgTeam[this.props.carID]) {
                    this.setState({
                        messageTooltip: "Pending Team Message",
                        messageBackground: "#ffbd00",
                        messageIcon: "fas fa-users",
                        messageAdditionalClass: " blink",
                    });
                }
                if (this.props.pendingMsgOrg[this.props.carID]) {
                    this.setState({
                        messageTooltip: "Pending ORG Message",
                        messageBackground: "#b90019",
                        messageIcon: "fas fa-user-tie",
                        messageAdditionalClass: " blink",
                    });
                }
            } else {
                this.setState({
                    messageTooltip: "Message Driver",
                    messageBackground: "",
                    messageIcon: "fas fa-envelope",
                    messageAdditionalClass: "",
                });
            }
        }
    }

    // GET DATA
    getMessageSet() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getEventMessageSet',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                eventID: helper.props.eventID,
            },
            success: function (data) {
                helper.setState({
                    messageSet: data,
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    updateWildcards() {
        let temp = {...this.state.messageWildcards};
        for (let i = 0; i < Object.keys(temp).length; i++) {
            // HARD-CODED wildcards for standard messages
            switch (Object.keys(temp)[i]) {
                case ('livery_number'): {
                    temp['livery_number'] = this.props.liveryNumber;
                    break;
                }
                default: {
                    break;
                }
            }
        }
        this.setState({
            messageWildcards: temp,
        });
    }

    // HANDLERS
    handleShowModal() {
        this.setState({
            show: true
        }, () => {
            $("#driverMessage").val("").focus();
        });
    }

    handleClose() {
        this.setState({
            show: false,
            messageResult: 0,
            teamOnlyMessage: false,
            messageHasTimeout: false,
            driverMessage: "",
            messageTooLong: false,
        });
    }

    handleClearDriverScreen() {
        const helper = this;
        let cmdType;
        if (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) {
            cmdType = "RT-ORG-CAR-MSG";
        } else {
            cmdType = "RT-GARAGE-CAR-MSG";
        }
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + telemetryPort + '/command-worker-device?command=' + cmdType + '-CLOSE&carId=' + helper.props.carID,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function () {
                console.log('[DASHBOARD] Successfully sent device message display closure request.');
                helper.setState({
                    driverMessage: "",
                    messageResult: 1,
                });
                helper.handleClose();
            }, error: function (err) {
                if (err) {
                    console.error('[DASHBOARD] Error sending device message display closure request.');
                    helper.setState({
                        messageResult: 2,
                    });
                    setTimeout(() => {
                        helper.handleClose();
                        helper.setState({
                            messageResult: 0,
                        });
                    }, 3000);
                }
            }
        });
    }

    handleSendMessage() {
        confirmSession(this.props.cookies.get("authToken"), this.props.eventID, this.props.sessionID, (isClosed) => {
            if (isClosed) {
                this.setState({
                    isSessionClosed: true,
                });
            } else {
                let cmdType = "";
                const helper = this;
                let message = this.state.driverMessage;

                if (this.state.teamOnlyMessage) {
                    $.ajax({
                        type: 'POST',
                        url: telemetryIP + ':' + telemetryPort + '/garage-team-direct-message?eventId=' + helper.props.eventID + '&sessionId=' + helper.props.sessionID + '&carId=' + helper.props.carID,
                        headers: {
                            'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
                        },
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify({
                            messageDetails: {
                                userId: helper.props.userID,
                                message: Accents.remove(message),
                            }
                        }),
                        success: function () {
                            console.log('[DASHBOARD] Successfully sent message team dashboard.');
                            helper.setState({
                                messageResult: 1,
                                driverMessage: "",
                            }, () => {
                                $("#driverMessage").val("").focus();
                            });
                        }, error: function (err) {
                            if (err) {
                                console.error('[DASHBOARD] Error sending message to team dashboard.', err);
                                helper.setState({
                                    messageResult: 2,
                                }, () => {
                                    $("#driverMessage").val("").focus();
                                });
                            }
                        }
                    });
                } else {
                    if (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) {
                        cmdType = "RT-ORG-CAR-MSG";
                    } else {
                        cmdType = "RT-GARAGE-CAR-MSG";
                    }
                    $.ajax({
                        type: 'POST',
                        url: telemetryIP + ':' + telemetryPort + '/command-worker-device?command=' + cmdType + '&carId=' + helper.props.carID + '&sessionId=' + helper.props.sessionID + '&eventId=' + helper.props.eventID + '&userId=' + helper.props.userID,
                        headers: {
                            'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
                        },
                        dataType: 'json',
                        data: {
                            message: Accents.remove(message),
                            messageTimeout: helper.state.messageTimeoutValue,
                        },
                        success: function () {
                            console.log('[DASHBOARD] Successfully sent device message display request.');
                            helper.setState({
                                messageResult: 1,
                                driverMessage: "",
                                messageTimeoutValue: 0,
                            }, () => {
                                $("#driverMessage").val("").focus();
                            });
                        }, error: function (err) {
                            if (err) {
                                console.error('[DASHBOARD] Error sending device message display request.', err);
                                helper.setState({
                                    messageResult: 2,
                                });
                                setTimeout(() => {
                                    helper.handleClose();
                                    helper.setState({
                                        messageResult: 0,
                                        messageTimeoutValue: 0,
                                    });
                                }, 3000);
                            }
                        }
                    });
                }
            }
        });
    }

    handleOnChangeMessage(evt) {
        this.setState({
            driverMessage: evt.target.value
        }, () => {
            if (this.state.driverMessage.length > this.state.messageCharacterLimit) {
                if (!this.state.messageTooLong) {
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("messageTooLong") + '!</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: "none",
                        offset: 150,
                    });
                }
                this.setState({
                    messageTooLong: true,
                });
            } else {
                this.setState({
                    messageTooLong: false,
                });
                Alert.closeAll();
            }
        });
    }

    handleTeamOnlyMessage(evt) {
        this.setState({
            teamOnlyMessage: !this.state.teamOnlyMessage,
        });
    }

    handleMessageTimeout(evt) {
        this.setState({
            messageHasTimeout: !this.state.messageHasTimeout,
        });
    }

    handleTimeoutChange(evt) {
        this.setState({
            messageTimeoutValue: parseInt(evt.target.value),
        });
    }

    handleStandardMessage(evt) {
        let finalMsg = evt.target.value;
        let regex = finalMsg.match(/<.*>/g);
        if (regex !== null && regex !== undefined && regex.length > 0) {
            finalMsg = finalMsg.replace(regex[0], this.state.messageWildcards[regex[0].substring(1, regex[0].length - 1)]);
        }
        this.setState({
            driverMessage: finalMsg,
        }, () => {
            $("#driverMessage").val(this.state.driverMessage);
        });
    }

    render() {
        let messageButtonDisable;
        if (!this.props.disable) {
            if ((this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) && this.props.carID) {
                messageButtonDisable = false;
            } else {
                messageButtonDisable = this.props.isOwnTeam !== 1;
            }
        } else {
            messageButtonDisable = true;
        }

        let message = "";
        if (this.state.messageResult === 1) {
            message = (<div className="alert alert-success" role="alert"><span className={"App_text"} style={{fontSize: 25}}><b>{this.props.t("confirmed")}!</b></span></div>);
        } else if (this.state.messageResult === 2) {
            message = (<div className="alert alert-danger" role="alert"><span className={"App_text"} style={{fontSize: 25}}><b>{this.props.t("actionError")}!</b></span></div>);
        } else {
            message = null;
        }

        return (
            <>
                {!this.props.isGuest ? (
                    <>
                        <button
                            className={"btn btn-primary btn-block button" + this.state.messageAdditionalClass}
                            data-tip={true}
                            data-for={"messageDriver_" + this.props.liveryNumber}
                            onClick={this.handleShowModal}
                            style={{background: this.state.messageBackground}}
                            disabled={messageButtonDisable}
                        >
                            <i className={this.state.messageIcon + " App_buttonContainer_icons"}/>
                        </button>
                        <ReactTooltip id={"messageDriver_" + this.props.liveryNumber} type={"light"}>
                            <span className={"toolTipStyle"}>{this.state.messageTooltip}</span>
                        </ReactTooltip>
                    </>
                ) : null}
                <SessionClosedModal isSessionClosed={this.state.isSessionClosed}/>
                <Modal open={this.state.show}
                       onClose={this.handleClose}
                       center={false}
                       classNames={{modal: "medium-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            {this.props.driverName === undefined ? (
                                <span className={"App_black_text"} style={{fontSize: 25}}> {this.props.t("sendMessageToVehicle")} <b>#{this.props.liveryNumber}</b></span>
                            ) : (
                                <span className={"App_black_text"} style={{fontSize: 25}}> {this.props.t("sendMessageTo")} <b>{this.props.driverName}</b></span>
                            )}
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <div className={"fluid-container"}>
                            <input type={"text"}
                                   id={"driverMessage"}
                                   className={"form-control App_black_text"}
                                   placeholder={this.props.t("writeYourMsg") + " (" + this.props.t("limitedTo") + " " + this.state.messageCharacterLimit + " " + this.props.t("chars") + "!)"}
                                   onChange={this.handleOnChangeMessage}
                            />
                            {message}
                            {(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? (
                                <>
                                    <div className={"row"} style={{marginTop: 10}}>
                                        <div className={"col-xs-4"}>
                                            <label className={"control control-checkbox text-center"} style={{marginTop: 10, display: "inline-flex"}}>
                                                <input
                                                    type={"checkbox"}
                                                    onClick={(event) => this.handleTeamOnlyMessage(event)}
                                                />
                                                <div className={"control_indicator"}/>
                                                <span className={"App_small_title"} style={{marginLeft: 10}}>{this.props.t("sendTeamOnly")}</span>
                                            </label>
                                        </div>
                                        <div className={"col-xs-5"}>
                                            <label className={"control control-checkbox text-center"} style={{marginTop: 10, display: "inline-flex"}}>
                                                <input
                                                    type={"checkbox"}
                                                    onClick={(event) => this.handleMessageTimeout(event)}
                                                />
                                                <div className={"control_indicator"}/>
                                                <span className={"App_small_title"} style={{marginLeft: 10}}>{this.props.t("applyTimeout")}</span>
                                            </label>
                                        </div>
                                        <div className={"col-xs-3"}>
                                            <button
                                                className={"btn btn-primary button"}
                                                data-toggle={"collapse"}
                                                data-target={"#stdMsg"}
                                                aria-controls={"stdMsg"}
                                            >
                                                <span><i className="fas fa-envelope-open-text"/></span>
                                                <span>{this.props.t("standard")}</span>
                                            </button>
                                        </div>
                                        {this.state.messageHasTimeout ? (
                                            <div className={"col-xs-6 w3-animate-fading"}>
                                                <br/>
                                                <label className={"App_small_title"}>{this.props.t("messageWillDisappear")}</label>
                                                <input
                                                    className={"form-control App_black_text"}
                                                    type={"number"}
                                                    placeholder={this.props.t("valueInSeconds")}
                                                    onChange={this.handleTimeoutChange}
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className={"row"}>
                                        <div className={"col-xs-12"}>
                                            <br/>
                                            <div id={"stdMsg"} className={"collapse"}>
                                                <div className={"col-xs-12 card card-body"}>
                                                    {this.state.messageSet.map((message, i) => {
                                                        return (
                                                            <button
                                                                key={"std_msg_" + i}
                                                                className={"btn btn-primary button"}
                                                                style={{fontSize: 18, fontWeight: "bold", margin: "5px 5px 0 0"}}
                                                                value={message.message}
                                                                onClick={this.handleStandardMessage}
                                                            >
                                                                {message.short_title}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.handleSendMessage}
                            disabled={this.state.driverMessage.length > this.state.messageCharacterLimit}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("showMessage")}
                        </button>
                        <button
                            onClick={this.handleClearDriverScreen}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("clearDriverScreen")}
                        </button>
                        <button
                            onClick={this.handleClose}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(MessageComponent));
